import { render, staticRenderFns } from "./referrals-export-button.vue?vue&type=template&id=8b98fe76"
import script from "./referrals-export-button.vue?vue&type=script&lang=js"
export * from "./referrals-export-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports